import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import numeral from 'numeral';
import moment from 'moment';

import BlankState from '../../../components/BlankState';
import DataTable from '../../../components/DataTable';
import Page from '../../../components/Page';


import { listClaims } from '../../../actions/claims';

class Claims extends Component{

	componentDidMount() {
		this.props.listClaims();
	}
	
	componentWillReceiveProps(){}
	
	render(){
		const { claims } = this.props;

		return(
			<Page isAdminPage={ true } pageTitle="Claims">
				<div className="clearfix card">
				{
					claims.claims.length > 0 ?
						<DataTable 
							tableId="claims-table"
							columnTitles={ 
								["Policy Number", "Place of Loss", "Claim Amount", "Claim Type", "Claim Status", "Date Filed"] 
							}>

						{
							claims.claims.map((claim, index) => {
								const { policy_number, Place_of_Loss, claim_amount, claim_type, claim_status, date_filed } = claim;

								return(
									<tr key={ index }>
										<td>{ policy_number }</td>
										<td>{ Place_of_Loss }</td>
										<td>{ numeral(claim_amount).format('0,0') }</td>
										<td>
											<span className="label label-default">{ claim_type }</span>
										</td>
										<td>
											<span 
												className={ 'label label-' + (claim_status === 'PAID_FULLY' ? 'success' : 'warning') } >
												
												{ claim_status }
											</span>
										</td>
										<td>{ moment(date_filed).format('MMM Do, YYYY') }</td>
									</tr>
								)
							})
						}
						</DataTable>
					:
						<BlankState 
							data={ claims.claims } 
							dataName="Claims" 
							isDataLoading={ claims.claims_loading } />
				}
				</div>
			</Page>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	user: state.user,
	claims: state.claims
});

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({ listClaims }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Claims);


// WEBPACK FOOTER //
// ./src/pages/dashboard/policies/Claims.jsx